import Typography from "ds/components/Typography";

import { AzureIntegrationView } from "../../useSearchCloudIntegrations/gql";
import styles from "./styles.module.css";

type DeleteConfirmationContentProps = {
  integration: AzureIntegrationView;
};

const AzureIntegrationDeleteConfirmationContent = ({
  integration,
}: DeleteConfirmationContentProps) => {
  return (
    <div>
      <Typography className={styles.text} tag="p" margin="0 0 large 0">
        Are you sure you want to delete the integration:
      </Typography>
      <div className={styles.details}>
        <Typography className={styles.detailsLabel} tag="p">
          Name
        </Typography>
        <Typography tag="p">{integration.name}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Type
        </Typography>
        <Typography tag="p">Azure</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Tenant
        </Typography>
        <Typography tag="p">{integration.tenantId}</Typography>
        <Typography className={styles.detailsLabel} tag="p">
          Default subscription
        </Typography>
        <Typography tag="p">{integration.defaultSubscriptionId}</Typography>
      </div>
      <Typography className={styles.text} tag="p">
        Note that deleting the integration will not remove the Enterprise Application from your
        Azure account, but Spacelift will no-longer be able to access it.
      </Typography>
    </div>
  );
};

export default AzureIntegrationDeleteConfirmationContent;
